exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table td{padding:1.1rem .75rem}.table tr.tfoot,.table tr.tfoot td{background:#f5f5f5!important}.table th.bg-green-light{background:#ccd3cf!important}.table td.bg-gray-light{background:#f5f5f5!important}.table tfoot th b{display:block;padding:12px 0;text-transform:uppercase}.link-underline{border-bottom:1px dashed #1b1e21}.link-underline:hover{border:none}.table-max-font-size{font-size:120%!important}", ""]);

// exports
